export const getItemFromLS = (key) => {
  return localStorage.getItem(key);
};

export const removeItemFromLS = (key) => localStorage.removeItem(key);

export const setItemInLS = (key, data) => {
  localStorage.setItem(key, data);
};
